var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconproductTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4508 30.5651C44.4424 30.5651 50.1102 24.8972 50.1102 17.9056C50.1102 10.9139 44.4424 5.24609 37.4508 5.24609C30.4591 5.24609 24.7913 10.9139 24.7913 17.9056C24.7913 24.8972 30.4591 30.5651 37.4508 30.5651ZM37.4508 25.9019C41.8666 25.9019 45.4463 22.3222 45.4463 17.9064C45.4463 13.4907 41.8666 9.91098 37.4508 9.91098C33.0351 9.91098 29.4554 13.4907 29.4554 17.9064C29.4554 22.3222 33.0351 25.9019 37.4508 25.9019Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1147 20.2826C17.1872 18.5818 18.5871 17.2402 20.2895 17.2402H53.9483C55.6507 17.2402 57.0507 18.5818 57.1231 20.2826L58.584 54.5709C58.661 56.3774 57.2173 57.8839 55.4092 57.8839H18.8286C17.0206 57.8839 15.5769 56.3774 15.6538 54.5709L17.1147 20.2826Z",
    fill: "#99C2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91789 26.946C8.00183 25.2543 9.39789 23.9258 11.0917 23.9258H48.3526C50.0464 23.9258 51.4425 25.2543 51.5264 26.946L53.1618 59.9017C53.2518 61.7163 51.8048 63.2368 49.988 63.2368H9.45632C7.63949 63.2368 6.19251 61.7163 6.28255 59.9017L7.91789 26.946Z",
    fill: "#1162FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0478 28.5898C24.0478 31.9088 26.7383 34.5993 30.0572 34.5993C33.3761 34.5993 36.0666 31.9088 36.0666 28.5898H40.0387C40.0387 34.1025 35.5698 38.5714 30.0572 38.5714C24.5446 38.5714 20.0757 34.1025 20.0757 28.5898H24.0478Z",
    fill: "#272727"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9948,
    cy: 47.5059,
    r: 11.3929,
    transform: "rotate(-45 51.9948 47.5059)",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "black",
    strokeWidth: 4.27234
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9066 54.0478L60.8899 52.0311L56.8565 56.0645L58.8732 58.0811L62.9066 54.0478ZM66.09 65.298C67.2038 66.4118 69.0096 66.4118 70.1234 65.298C71.2372 64.1842 71.2372 62.3784 70.1234 61.2646L66.09 65.298ZM58.8732 58.0811L66.09 65.298L70.1234 61.2646L62.9066 54.0478L58.8732 58.0811Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconproductTutorial);
export default __webpack_public_path__ + "static/media/icon.product_tutorial.5c096d61281a649a38cc001a65bbae70.svg";
export { ForwardRef as ReactComponent };